import { render, staticRenderFns } from "./ListRefundsView.vue?vue&type=template&id=35bb3200"
import script from "./ListRefundsView.vue?vue&type=script&lang=js"
export * from "./ListRefundsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports